import { apiClient } from '@/lib/api-client';
import type {
  ApiResponse,
  PaginatedResponse,
  Unit,
  CreateUnitRequest,
  UpdateUnitRequest,
} from '@/types/api';

export interface GetUnitsParams {
  buildingId?: string;
  search?: string;
  page?: number;
  perPage?: number;
}

export async function getUnits(params: GetUnitsParams = {}): Promise<PaginatedResponse<Unit>> {
  const query = new URLSearchParams();
  if (params.buildingId) query.set('buildingId', params.buildingId);
  if (params.search) query.set('search', params.search);
  if (params.page) query.set('page', String(params.page));
  if (params.perPage) query.set('perPage', String(params.perPage));

  const response = await apiClient.get<PaginatedResponse<Unit>>(`/units?${query.toString()}`);
  return response.data;
}

export async function getUnit(id: string): Promise<ApiResponse<Unit>> {
  const response = await apiClient.get<ApiResponse<Unit>>(`/units/${id}`);
  return response.data;
}

export async function createUnit(data: CreateUnitRequest): Promise<ApiResponse<Unit>> {
  const response = await apiClient.post<ApiResponse<Unit>>('/units', data);
  return response.data;
}

export async function updateUnit(id: string, data: UpdateUnitRequest): Promise<ApiResponse<null>> {
  const response = await apiClient.put<ApiResponse<null>>(`/units/${id}`, data);
  return response.data;
}

export async function deleteUnit(id: string): Promise<ApiResponse<null>> {
  const response = await apiClient.delete<ApiResponse<null>>(`/units/${id}`);
  return response.data;
}
